import { Trans, useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import { helpCenterUrl } from '@/lib/helpCenter'

interface TermsNoticeProps {
  /** Which action the sentence names: creating an account or setting the invite password. */
  action?: 'signup' | 'setPassword'
  className?: string
}

/**
 * The small "by signing up you agree to the Terms of Use" line shown wherever a
 * person creates their own account. The link opens the Help Center article in
 * the reader's language, in a new tab so the form keeps what was typed.
 */
export const TermsNotice = ({ action = 'signup', className }: TermsNoticeProps) => {
  const { t, i18n } = useTranslation('auth')
  const href = helpCenterUrl(i18n.language, 'conceitos/termos-de-uso')

  return (
    <p className={cn('text-center text-xs text-gray-500', className)} data-testid="terms-notice">
      <Trans
        t={t}
        i18nKey={action === 'setPassword' ? 'terms.setPasswordNotice' : 'terms.signupNotice'}
        components={{
          link: <a href={href} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:text-gray-700" />
        }}
      />
    </p>
  )
}
